import { getInitials } from 'utils'
import { Badge } from './Badge'
import { UserBadgeProps } from './Types'

export const UserBadge = ({ recipient, ...props }: UserBadgeProps) => {
  const { avatar_url, display_name } = recipient
  return <Badge avatar={{ url: avatar_url, title: getInitials(display_name) }} title={display_name} {...props} />
}
